import React from 'react';

import { useDispatch } from 'react-redux';
import { useInternationalization } from '@progress/kendo-react-intl';

import { downloadDoc, removePin } from '../../../services/documentsService';

import { PDF, PIN, POPUP } from '../../../../redux/types';

import { ICard } from '../../types/IDocumentPinsCard';

import Pin from '../../button/pin/pin';

import './documentPinsCard.scss';

const DocumentPinsCard: React.FC<ICard> = ({ item }) => {
  const dispatch = useDispatch();
  const intl = useInternationalization();

  const handlePinClick = () => {
    removePin(item.assignId).then(() => {
      dispatch({ type: PIN.PIN_TRIGGER });
    }).catch((err) => dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message }));
  };

  return (
    <div className={'card-container'}>
      <div className={'card-header'}>
        {item.fileType.toLowerCase() === 'pdf' ? (
          <div className="pointer" onClick={() => dispatch({ type: PDF.SHOW_PDF_DIALOG, payload: item.assignId})}>
            <p className={'label'}>{item.label}</p>
          </div>
        ) : (
          <span className={'pointer'}
                onClick={() => downloadDoc(item).catch((err) => dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message }))}>
            <p className={'label'}>{item.label}</p>
          </span>
        )}
        <div className='card-header-commands'>
          <p className={'card-text-span'}>{intl.formatDate(new Date(item.date), 'd')}</p>
          <Pin clickHandler={handlePinClick} isPinned={true} className={'pointer'} />
        </div>
      </div>
      <p className={'card-text-span'}>{item.fundName}</p>
      <p className={'card-text-span'}>{item.objectName}</p>
    </div>
  );
};

export default DocumentPinsCard;
